import { PageHeader } from '../../components/PageHeader';
import { PagosTable, PAGOS_TABLE_SCOPE } from './components/PagosTable';
import { useT } from '../../locales';

export function PagosListPage() {
  const t = useT();
  return (
    <div>
      <PageHeader title={t('pages.pagos.title')} subtitle={t('pages.pagos.subtitle')} />
      <PagosTable scope={PAGOS_TABLE_SCOPE.GLOBAL} />
    </div>
  );
}
